import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { AppContext } from "../AppContextProvider";
import close from "../assets/media/icons/cross-thin.svg";

import {
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBBtn,
} from "mdb-react-ui-kit";

export default function InfoModalLeft(props) {
  const { t } = useTranslation();
  const context = useContext(AppContext);

  return (
    <>
      <MDBModal staticBackdrop tabIndex="-1" closeOnEsc={false} show={props.visible} className="central-info-modal">
        <MDBModalDialog scrollable centered>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>
                <span className="title-text">{t('modals.web3Ecosystem.title')}</span>
              </MDBModalTitle>
              <MDBBtn className="button subtle large" type="button" onClick={props.hideModal}>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M8.70703 8L13.8535 2.85352C14.0488 2.6582 14.0488 2.3418 13.8535 2.14648C13.6582 1.95117 13.3418 1.95117 13.1465 2.14648L8 7.29297L2.85352 2.14648C2.6582 1.95117 2.3418 1.95117 2.14648 2.14648C1.95117 2.3418 1.95117 2.6582 2.14648 2.85352L7.29297 8L2.14648 13.1465C1.95117 13.3418 1.95117 13.6582 2.14648 13.8535C2.24414 13.9512 2.37207 14 2.5 14C2.62793 14 2.75586 13.9512 2.85352 13.8535L8 8.70703L13.1465 13.8535C13.2441 13.9512 13.3721 14 13.5 14C13.6279 14 13.7559 13.9512 13.8535 13.8535C14.0488 13.6582 14.0488 13.3418 13.8535 13.1465L8.70703 8Z"
                    fill="var(--text-accent-maxi)"
                  />
                </svg>
              </MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              <div className="content">
                <h3 className="text-wrapper">{t('modals.web3Ecosystem.subtitle')}</h3>
                <p className="div p18">
                  {t('modals.web3Ecosystem.intro')}
                </p>
                <h4 className="p">{t('modals.web3Ecosystem.keyComponents')}</h4>
                <ul className="decentralization-at">
                  <li>
                    <span className="span">{t('modals.web3Ecosystem.decentralization')}</span>
                    <span className="text-wrapper-2">
                      {t('modals.web3Ecosystem.decentralizationDesc')}
                      <br />
                    </span>
                  </li>
                  <li>
                    <span className="span">{t('modals.web3Ecosystem.blockchainTechnology')}</span>
                    <span className="text-wrapper-2">
                      {t('modals.web3Ecosystem.blockchainTechnologyDesc')}
                      <br />
                    </span>
                  </li>
                  <li>
                    <span className="span">{t('modals.web3Ecosystem.cryptocurrenciesAndTokens')}</span>
                    <span className="text-wrapper-2">
                      {t('modals.web3Ecosystem.cryptocurrenciesAndTokensDesc')}
                      <br />
                    </span>
                  </li>
                  <li>
                    <span className="span">{t('modals.web3Ecosystem.dApps')}</span>
                    <span className="text-wrapper-2">
                      {t('modals.web3Ecosystem.dAppsDesc')}
                      <br />
                    </span>
                  </li>
                  <li>
                    <span className="span">{t('modals.web3Ecosystem.did')}</span>
                    <span className="text-wrapper-2">
                      {t('modals.web3Ecosystem.didDesc')}
                      <br />
                    </span>
                    <span className="span">{t('modals.web3Ecosystem.interoperability')}</span>
                    <span className="text-wrapper-2">
                      {t('modals.web3Ecosystem.interoperabilityDesc')}
                    </span>
                  </li>
                </ul>
                <p className="citations-https">
                  {t('modals.web3Ecosystem.citations')}
                  <br />
                  [1]{" "}
                  <a
                    href="https://helalabs.com/blog/10-key-features-of-web3-that-you-need-to-know"
                    target="_blank"
                    rel="noreferrer"
                  >
                    https://helalabs.com/blog/10-key-features-of-web3-that-you-need-to-know
                  </a>
                  <br />
                  [2]{" "}
                  <a
                    href="https://blog.daisie.com/web3-ecosystem-explained-guide-to-tools-platforms"
                    target="_blank"
                    rel="noreferrer"
                  >
                    https://blog.daisie.com/web3-ecosystem-explained-guide-to-tools-platforms
                  </a>
                  <br />
                  [3]{" "}
                  <a href="https://technews180.com/blog/trends-web3" target="_blank" rel="noreferrer">
                    https://technews180.com/blog/trends-web3
                  </a>
                  <br />
                  [4]{" "}
                  <a
                    href="https://www.linkedin.com/pulse/web-30-its-ecosystem-aashish-sinha"
                    target="_blank"
                    rel="noreferrer"
                  >
                    https://www.linkedin.com/pulse/web-30-its-ecosystem-aashish-sinha
                  </a>
                  <br />
                  [5]{" "}
                  <a href="https://coinmarketcap.com/academy/article/what-is-web-3-0" target="_blank" rel="noreferrer">
                    https://coinmarketcap.com/academy/article/what-is-web-3-0
                  </a>
                  <br />
                  [6]{" "}
                  <a href="https://mightyblock.co/blog/web3-2024-trends" target="_blank" rel="noreferrer">
                    https://mightyblock.co/blog/web3-2024-trends
                  </a>
                  <br />
                  [7]{" "}
                  <a href="https://ethereum.org/en/web3" target="_blank" rel="noreferrer">
                    https://ethereum.org/en/web3
                  </a>
                  <br />
                  [8]{" "}
                  <a href="https://en.wikipedia.org/wiki/Web3" target="_blank" rel="noreferrer">
                    https://en.wikipedia.org/wiki/Web3
                  </a>
                  <br />
                  [9]{" "}
                  <a
                    href="https://rzlt.io/powerful-web3-trends-in-2024-you-need-to-know-about"
                    target="_blank"
                    rel="noreferrer"
                  >
                    https://rzlt.io/powerful-web3-trends-in-2024-you-need-to-know-about
                  </a>
                </p>
              </div>
            </MDBModalBody>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </>
  );
}
